import React from "react";
import PropTypes from "prop-types";
import { FormMenu } from "../../../components/Buttons";

import { connect } from "react-redux";
import { resetPassword } from "../../../redux/actions/auth";

const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => ({
  resetPassword: (...args) => dispatch(resetPassword(...args)),
});

const PasswordResetConfirmationDialog = (props) => {
  const { className, user, resetPassword, onClose } = props;

  const onSave = () => {
    resetPassword(user);
    onClose && onClose();
  };
  const onCancel = () => {
    onClose && onClose();
  };

  if (!user) return null;
  const { firstname, lastname } = user;
  const text = `Wollen Sie das Passwort für den Mitarbeiter ${firstname} ${lastname} wirklich zurücksetzen?`;
  return (
    <div className={className}>
      <div className="w3-large">{text}</div>
      <FormMenu
        className="margin-lg-top w3-border-top pad-big w3-light-grey"
        style={{
          marginLeft: "-1em",
          marginRight: "-1em",
          marginBottom: "-1em",
        }}
        onSave={onSave}
        onCancel={onCancel}
        saveBtnName="resetPasswordBtn"
        saveBtnLabel="Ja"
        cancelBtnLabel="Nein"
      />
    </div>
  );
};

PasswordResetConfirmationDialog.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape({}),
  resetPassword: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
PasswordResetConfirmationDialog.defaultProps = {
  className: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordResetConfirmationDialog);
